import React, { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { InfoPageTitle, CustomAccordion } from 'views/common/components';
import StyledBox from 'views/information-module/PrivacyPolicyView/PrivacyPolicyView.styles';
import { Container, Typography } from '@mui/material';
import Head from 'next/head';
import axios, { API } from 'lib/config/axios';
import generateMetaData from 'lib/utils/generateMetaData';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import PATHS from 'lib/navigation/paths';

const PrivacyPolicyView = (props) => {
  const { t } = useTranslation('fe_er_privacy_policy_page');
  const handleErrorResponse = useErrorsHandler();
  const { serverData } = props;
  const [seoValues, setSeoValues] = useState(serverData);
  const getSeoValuesData = () => {
    axios
      .get(API.seoValues)
      .then((res) => {
        setSeoValues(res.data);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };
  useEffect(() => {
    if (!serverData) {
      getSeoValuesData();
    }
  }, []);
  const mainTitleObject = {
    name: t('fe_er_privacy_policy_page:er_privacy_policy'),
  };
  const breadcrumbsObject = {
    links: [
      {
        text: t('fe_er_privacy_policy_page:eagleRider'),
        path: PATHS.home(),
      },
      {
        text: t('fe_er_privacy_policy_page:information'),
        path: PATHS.information(),
      },
      {
        text: t('fe_er_privacy_policy_page:privacy_policy'),
      },
    ],
  };
  const policiesData = [
    {
      id: 1,
      title: t('fe_er_privacy_policy_page:privacy_policy_purpose'),
      desc: t('fe_er_privacy_policy_page:privacy_policy_purpose_data'),
    },
    {
      id: 2,
      title: t('fe_er_privacy_policy_page:personal_info_collection'),
      desc: t('fe_er_privacy_policy_page:personal_info_collection_data'),
    },
    {
      id: 3,
      title: t('fe_er_privacy_policy_page:franchises'),
      desc: t('fe_er_privacy_policy_page:franchises_data'),
    },
    {
      id: 4,
      title: t('fe_er_privacy_policy_page:web_site_tracking'),
      desc: t('fe_er_privacy_policy_page:web_site_tracking_data'),
    },
    {
      id: 5,
      title: t('fe_er_privacy_policy_page:analytics'),
      desc: t('fe_er_privacy_policy_page:analytics_data'),
    },
    {
      id: 6,
      title: t('fe_er_privacy_policy_page:personal_info_security'),
      desc: t('fe_er_privacy_policy_page:personal_info_security_data'),
    },
    {
      id: 7,
      title: t('fe_er_privacy_policy_page:personal_info_update'),
      desc: t('fe_er_privacy_policy_page:personal_info_update_data'),
    },
    {
      id: 8,
      title: t('fe_er_privacy_policy_page:sms_telephone_consent'),
      desc: t('fe_er_privacy_policy_page:sms_telephone_consent_desc'),
    },
    {
      id: 9,
      title: t('fe_er_privacy_policy_page:data_deletion'),
      desc: t('fe_er_privacy_policy_page:data_deletion_desc', {
        acclink: PATHS.user.dashboard().url,
        settingAccLink: PATHS.user.personalInfo().url,
        contactLink: PATHS.contactUs().url,
      }),
    },
    {
      id: 10,
      title: t('fe_er_privacy_policy_page:applicable_law'),
      desc: t('fe_er_privacy_policy_page:applicable_law_data'),
    },
    {
      id: 11,
      title: t('fe_er_privacy_policy_page:privacy_policy_changes'),
      desc: t('fe_er_privacy_policy_page:privacy_policy_changes_data'),
    },
  ];
  return (
    <>
      <Head>{seoValues && generateMetaData(seoValues)}</Head>
      <StyledBox className="overFlowXHidden">
        <InfoPageTitle
          mainTitleObject={mainTitleObject}
          breadcrumbsObject={breadcrumbsObject}
          buttonText={t('fe_er_privacy_policy_page:start_reservation')}
        />
        <Container maxWidth="xl">
          <Typography variant="body1" component="p" className="PPVNoteText">
            {t('fe_er_privacy_policy_page:note')}
          </Typography>
          {policiesData.map((item) => (
            <CustomAccordion
              key={item.id}
              accordionTitle={item.title}
              accordionDesc={item.desc}
            />
          ))}
        </Container>
      </StyledBox>
    </>
  );
};
export { PrivacyPolicyView };
